import { PageHero } from "../components/PageHero";
import { FAQAccordion } from "../components/FAQAccordion";
import { CTABand } from "../components/CTABand";
import { FAQ } from "../data";

export default function FAQPage({ onApply }) {
  return (
    <>
      <PageHero media="/videos/clip4.mp4" overline="FAQ" title="Your questions," highlight="answered." subtitle="Everything you need to know about training, licences, accommodation and studying with us in South Africa." />
      <section className="py-24 lg:py-32 bg-white" data-testid="faq-section">
        <div className="max-w-7xl mx-auto px-6"><FAQAccordion items={FAQ} /></div>
      </section>
      <CTABand onApply={onApply} title="Still have questions?" text="Reach out to our friendly team — we're always happy to help you plan your journey into aviation." />
    </>
  );
}
